import { biLoggerFactory } from 'wix-private';
import { getMetasiteId } from '../public/getMetasiteId.js';

export async function fireBIEvent(src, evid, fields) {
    const msid = await getMetasiteId();
    const biGroupsLoggers = {
        19: biLoggerFactory('blog', 19, { msid }),
        69: biLoggerFactory('blog-app-uou', 69, { msid })
    }

    const biLogger = biGroupsLoggers[src];
    try {
        const biEventObject = {
            evid,
            ...fields
        };
        await biLogger.log(biEventObject);
    } catch (err) {
        console.error(`Failed to fireBIEvent -err- ${err}`);
    }
}
